import clsx from 'clsx';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '../../../lib/auth';
import AuthLayout from '../../layouts/AuthLayout';
import Skeleton from '../../../components/Skeleton';
import { PlanResults } from '../../../components/plan/PlanResults';
import { PlanTabs } from '../../../components/plan/PlanTabs';
import { usePlan } from '../../../lib/plan/usePlan';
import { usePlanHistory } from '../../../lib/plan/usePlanHistory';

export default function PlanResultsPage() {
    useAuth({
        middleware: 'auth',
        redirectTo: '/',
        tmp: 'PlanResultsPage',
    });

    const navigate = useNavigate();
    const { plan, isLoading } = usePlan();
    const {
        history,
        error: historyError,
        isLoading: isHistoryLoading,
        mutate: mutateHistory,
    } = usePlanHistory();

    useEffect(() => {
        if (!isLoading && plan === null) {
            navigate('/plan-na-miru/dotaznik');
        }
    }, [isLoading, plan, navigate]);

    if (isLoading || isHistoryLoading || plan === null) {
        return (
            <AuthLayout>
                <main
                    className={clsx(
                        'relative',
                        'mx-auto box-content max-w-5xl py-9',
                        'px-4 sm:px-8 md:px-10'
                    )}
                >
                    <Skeleton className="mb-6 h-64 w-full rounded-2xl" />
                    <Skeleton className="h-40 w-full rounded-2xl" />
                </main>
            </AuthLayout>
        );
    }

    return (
        <AuthLayout>
            <main
                className={clsx(
                    'relative',
                    'mx-auto box-content max-w-5xl py-9',
                    'px-4 sm:px-8 md:px-10'
                )}
            >
                <h1 className="mb-6">Plán na míru</h1>
                <div className="mb-10">
                    <PlanTabs />
                </div>
                <PlanResults
                    plan={plan}
                    history={history}
                    historyError={!!historyError}
                    onRetryHistory={() => mutateHistory()}
                />
            </main>
        </AuthLayout>
    );
}
